import { render, staticRenderFns } from "./CartConfirm.vue?vue&type=template&id=5c6735e5&scoped=true&"
import script from "./CartConfirm.vue?vue&type=script&lang=js&"
export * from "./CartConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6735e5",
  null
  
)

export default component.exports